export default __webpack_public_path__ + "assets/models/84b8014ada2b5c1d69726bf97636e38f.glb";